import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { affiliations } from '../../helpers/analytics-utils/constants';
import { discountedPriceRange, priceRange } from '../../helpers/price-ranges';

function imageUrl(image) {
  return typeof image === 'string' ? image : image === null || image === void 0 ? void 0 : image.url;
}

function calculatePrice(product) {
  var _discountedPriceRange;

  if (isSGPageTemplateProduct(product)) {
    if (product.discountedPrice) {
      return parseFloat(product.discountedPrice.split('-')[0].replace('$', ''));
    } else if (product.price) {
      return parseFloat(product.price.replace('$', ''));
    } else {
      return 0;
    }
  }

  const productPriceRange = (_discountedPriceRange = discountedPriceRange(product)) !== null && _discountedPriceRange !== void 0 ? _discountedPriceRange : priceRange(product);
  return productPriceRange === null || productPriceRange === void 0 ? void 0 : productPriceRange.min;
}

export function makeProductClickedForVariantGroup(product, sortMethod, listId) {
  var _product$promotions;

  const price = calculatePrice(product);

  const eventProperties = _objectSpread(_objectSpread({
    category: 'Ecommerce',
    cart_affiliation: affiliations.WESTFIELD_DIRECT_AU,
    product_id: product.variantGroupCode,
    label: 'product_clicked',
    list_id: listId,
    sort_method: sortMethod,
    image_url: imageUrl(product.image),
    currency: 'AUD',
    price
  }, makeProductDataForVariantGroup(product)), {}, {
    promotions: (_product$promotions = product.promotions) === null || _product$promotions === void 0 ? void 0 : _product$promotions.map(promotion => ({
      promotion_type: 'auto',
      promotion_id: promotion.campaignId,
      promotion_name: promotion.title
    }))
  });

  return {
    object: 'Product',
    action: 'Clicked',
    properties: eventProperties
  };
}

const isSGPageTemplateProduct = product => product.__typename === 'SGPageTemplateProduct';

function makeProductDataForVariantGroup(product) {
  var _product$brand, _product$shop$retaile2;

  if (isSGPageTemplateProduct(product)) {
    var _product$shop$retaile;

    return {
      name: product.title,
      brand: product.brand || '',
      retailer_name: product.shop.name || undefined,
      retailer_id: (_product$shop$retaile = product.shop.retailer) === null || _product$shop$retaile === void 0 ? void 0 : _product$shop$retaile.sys.id,
      image_url: product.image.url
    };
  }

  return {
    name: product.name,
    brand: ((_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.name) || '',
    retailer_name: product.shop.name || undefined,
    retailer_id: (_product$shop$retaile2 = product.shop.retailer) === null || _product$shop$retaile2 === void 0 ? void 0 : _product$shop$retaile2.sys.id,
    image_url: product.image
  };
}